/**
 * GENERATED by `node scripts/cdn-icons.mjs`; do not edit. Every icon v1 draws from the CDN (S3), by name, as its
 * file under `CDN_ICON_BASE` (DESIGN_SYSTEM.md §5.1). Drawn by `Icon`'s `cdn` kind: an `Image` on web, react-native-svg's
 * `SvgUri` for an SVG on native (React Native's `Image` cannot draw one). Like v1, a CDN icon needs the network the
 * first time it is drawn.
 */

/** v2's copy of v1's `CDN_ORACLE_URL` (rule 14; `docs/V1_DUPLICATES.md`), with its trailing slash */
export const CDN_ICON_BASE = "https://cdn.dotpe.in/oracle/";

export const CDN_ICONS = {
  "Amount+Due": "Amount+Due.svg",
  Info: "Info.svg",
  "accepted-order-icon": "accepted-order-icon.png",
  access: "access.svg",
  add_icon: "add_icon.svg",
  ai_loader: "ai_loader.gif",
  analytics: "analytics.svg",
  app_scan_black: "app_scan_black.svg",
  app_scan_blue: "app_scan_blue.svg",
  barcode: "barcode.svg",
  billing_order: "billing_order.svg",
  blackDesktopIcon: "blackDesktopIcon.svg",
  blueDesktopIcon: "blueDesktopIcon.svg",
  bluePrinterIcon: "bluePrinterIcon.svg",
  blueTuneIcon: "blueTuneIcon.svg",
  cancel: "cancel.svg",
  "cash-register-unselected": "cash-register-unselected.svg",
  "cash-register": "cash-register.svg",
  catalogue: "catalogue.svg",
  "check-mark": "check-mark.png",
  check_icn: "check_icn.svg",
  checkout_icn: "checkout_icn.svg",
  chef: "chef.svg",
  close_icn: "close_icn.svg",
  cod: "cod.png",
  collapse: "collapse.svg",
  customer_id_black: "customer_id_black.svg",
  customer_id_blue: "customer_id_blue.svg",
  customers: "customers.svg",
  cutlery: "cutlery.svg",
  "delete-icon": "delete-icon.svg",
  discard: "discard.svg",
  discount_icn: "discount_icn.svg",
  egg: "egg.svg",
  error: "error.svg",
  expenses: "expenses.svg",
  "floppy-disk-3": "floppy-disk-3.svg",
  grid: "grid.svg",
  hold: "hold.svg",
  "ic-company-sm": "ic-company-sm.svg",
  "ic-customer-display": "ic-customer-display.svg",
  inventory_management: "inventory_management.svg",
  logo_rista: "logo_rista.png",
  marketing: "marketing.svg",
  note_edit: "note_edit.svg",
  nveg: "nveg.svg",
  "phone-call-9": "phone-call-9.svg",
  printer: "printer.svg",
  printing_icn: "printing_icn.svg",
  processed_order_icon: "processed_order_icon.png",
  report: "report.svg",
  reservations: "reservations.svg",
  "rista-ai-icon": "rista-ai-icon.png",
  rista_cards: "rista_cards.svg",
  rista_logo_black: "rista_logo_black.svg",
  "rupee-symbol": "rupee-symbol.svg",
  rupee_icn: "rupee_icn.svg",
  self: "self.png",
  spicy: "spicy.svg",
  star: "star.svg",
  support: "support.svg",
  telephone_keypad_black: "telephone_keypad_black.svg",
  telephone_keypad_blue: "telephone_keypad_blue.svg",
  ticket_display: "ticket_display.svg",
  "transfer-In": "transfer-In.svg",
  "transfer-out": "transfer-out.svg",
  transfer: "transfer.svg",
  user_icon: "user_icon.svg",
  user_icon_black: "user_icon_black.svg",
  veg: "veg.svg",
} as const satisfies Record<string, string>;

export type CdnIconName = keyof typeof CDN_ICONS;

/** icons whose art is all white (v1 draws them on a coloured button): a gallery or a light ground shows them on a dark one */
export const CDN_ICONS_LIGHT: readonly CdnIconName[] = ["ai_loader","check_icn","checkout_icn","close_icn","discount_icn","floppy-disk-3","phone-call-9","printing_icn","rupee_icn"];
